export default {
  loading: 'Loading...',
  language: 'Language',
  languageZh: '中文',
  languageEn: 'English',
  noData: 'No data',
  confirm: 'Confirm',
  cancel: 'Cancel',
}
